import DriveInfoCard from '../components/driveDetails/DriveInfoCard';
import DriveList from '../components/driveDetails/DriveList';
import { useLocation } from 'react-router-dom';
import { Button } from '@mantine/core';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

export default function DriveDetails() {
  const location = useLocation();
  const theme = useTheme();
  const device = location.state?.device || {};

  const handleExportClick = (e) => {
    const button = e.currentTarget;
    const ripple = document.createElement('span');
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${e.clientX - button.getBoundingClientRect().left - radius}px`;
    ripple.style.top = `${e.clientY - button.getBoundingClientRect().top - radius}px`;
    ripple.style.backgroundColor = theme.palette.primary.contrastText;
    ripple.style.opacity = '0.5';
    ripple.classList.add('export-button-ripple');

    button.appendChild(ripple);

    setTimeout(() => {
      ripple.remove();
    }, 600);
  };

  return (
    <Box className="min-h-screen p-1" sx={{ backgroundColor: 'background.default' }}>
      <Box sx={{ margin: '0 auto', width: '75.5vw', maxWidth: '75.5vw' }}>
        <Box className="flex justify-between items-center mb-6">
          <Typography 
            variant="h3" 
            sx={{ 
              fontFamily: 'fontFamily', 
              color: 'text.primary',
              fontSize: '32px',
              fontWeight: 700 
            }}
          >
            Drive Details
          </Typography>
          <Button
            size="sm"
            variant="filled"
            className="export-button"
           
            onClick={handleExportClick}
          >
            <FontAwesomeIcon
              icon={faDownload}
              style={{
                height: '10px',
                width: '10px',
                color: 'primary.contrastText',
              }}
            />
            <span>Export Report</span>
          </Button>
        </Box>

        <DriveInfoCard device={device} />

        <Box className="flex flex-col gap-6 mt-6">
          {/* <OperationLog device={device} /> */}
          <DriveList device={device} />
        </Box>
      </Box>
    </Box>
  );
}